import { PaymentPartnerType } from '../../../../../codegen/vehicles';
import { ServiceCardTypeIcon } from '../../../../../components/icons/ServiceCardTypeIcon';

export const PaceCardRepresentation = ({
  cardName,
  paymentPartner,
}: {
  cardName: string;
  paymentPartner: PaymentPartnerType;
}) => {
  return (
    <div className={'display-flex'}>
      <div
        className={'min-width-200'}
        data-testid={'charge-card-form-card-alias'}
      >
        <ServiceCardTypeIcon
          type={paymentPartner}
          className="height-20 margin-right-10 margin-bottom-0"
        />
        <span>{cardName}</span>
      </div>
    </div>
  );
};
